Attributes of the conflicting position profile.
